import { useFeaturesForApiNames } from '../../../hooks/useFeatures';

// List of features from https://docs.google.com/document/d/1NCFquhj70TqTCfOIcZK-RWnsJMqa2ciSLL4U5f_jo3A/edit?tab=t.0
const apiNamesToFeatureShortNamesMap = {
  'marketing-hub-starter': ['forms', 'emailMarketing', 'simpleMarketingAutomation', 'adManagement', 'adRetargeting', 'liveChat', 'listSegmentation', 'cookieManagementTools'],
  'sales-hub-starter': ['1to1Email', 'templates', 'conversationalBots', 'meetings', 'breezeCopilotBeta', 'payments', 'liveChat', 'taskCalendarSync', 'taskQueues'],
  'service-hub-starter': ['multipleTicketPipelines', 'liveChat', 'ticketRouting', 'calling', 'snippets', 'conversationRouting', 'conversationsInbox', 'reportingDashboards'],
  'cms-hub-starter': ['websitePages', 'blog', 'landingPages', 'liveChat', 'contentLibrary', 'dragAndDropEditor', 'cookieManagementTools', 'designManager'],
  'operations-hub-starter': ['dataSync', 'crmExports', 'customFieldMappings', 'deals', 'customProperties', 'permissionSets']
};

// Somewhat copy of useCategorizedPriorityFeatures but modified for this experiment's feature list
export const useFTS0017AndFTS0018Features = ({
  apiName
}) => {
  const {
    loading,
    features
  } = useFeaturesForApiNames([apiName]);
  const featureShortNames = apiNamesToFeatureShortNamesMap[apiName];

  // This shouldn't happen since we're only using this hook for the starter hubs
  if (!featureShortNames) {
    return {
      loading,
      brandingAndLimitFeatures: [],
      uncategorizedFeatures: []
    };
  }
  const filteredFeatures = features.filter(feature => {
    return featureShortNames.includes(feature.shortName);
  });

  // Format from useFeaturesForApiNames is different from usePriorityFeaturesForApiName
  const transformedFeatures = filteredFeatures.map(feature => {
    return Object.assign({}, feature, {
      productApiName: apiName,
      shouldUseDefaultLimit: true,
      // does not affect rendering here, just makes TS happy
      description: feature.descriptions[apiName] || '',
      hideFromLang: feature.hideFromLang || undefined,
      featureType: (feature === null || feature === void 0 ? void 0 : feature.featureType) || undefined
    });
  });
  const brandingAndLimitFeatures = transformedFeatures.filter(feature => {
    return feature.featureType === 'LIMIT_INCREASE' || feature.featureType === 'REMOVE_BRANDING';
  });
  const uncategorizedFeatures = transformedFeatures.filter(feature => {
    return !feature.featureType;
  });
  return {
    loading,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  };
};